import React from 'react';
import Layout from '../components/Layout';
import LineSeperator from '../components/ui/LineSeperator';
import schoolImg from '../assets/SchoolBuilding.jpg';
import '../stylings/AboutSchool.css';

export default function AboutSchool() {
  return (
    <Layout bannerTitle="About School">
      <section className="inner-page-section">
        <div className="container-fluid px-5">
          <LineSeperator title="About Akash Model Sr. Sec. School" />
          <div className="row g-5 mt-2 align-items-center">
            <div className="col-lg-5">
              <img src={schoolImg} alt="School" className="inner-page-img" />
            </div>
            <div className="col-lg-7">
              <h3 className="inner-page-heading">Our Story</h3>
              <p>
                Akash Model Sr. Sec. School was established in 1991 with a mission to provide quality
                education to the students of Delhi NCR. Located in Baljeet Vihar, Nithari Extn.,
                near Rohini Sector-22, the school has grown into one of Delhi's premier educational institutions.
              </p>
              <p>
                Affiliated with the Central Board of Secondary Education (CBSE), our school offers education
                from Nursery to Class XII, covering all major streams — Science, Commerce, and Humanities.
              </p>
              <p>
                The school's motto <strong>"Work Is Worship"</strong> embodies the philosophy that
                consistent effort and dedication are the keys to success. Over 34 years, we have nurtured
                thousands of students who have gone on to achieve excellence in various fields.
              </p>
              <div className="about-info-grid">
                <div className="info-item"><strong>Established:</strong> 1991</div>
                <div className="info-item"><strong>Affiliation:</strong> CBSE, New Delhi</div>
                <div className="info-item"><strong>Medium:</strong> English</div>
                <div className="info-item"><strong>Classes:</strong> Nursery to XII</div>
                <div className="info-item"><strong>Streams:</strong> Science, Commerce, Humanities</div>
                <div className="info-item"><strong>Website:</strong> www.akashmodelschool.in</div>
              </div>
            </div>
          </div>
          <div className="row g-4 mt-4">
            <div className="col-md-4">
              <div className="vision-card">
                <i className="fas fa-eye vision-icon"></i>
                <h5>Our Vision</h5>
                <p>To be a leading educational institution that nurtures academically excellent, morally upright, and socially responsible citizens.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="vision-card">
                <i className="fas fa-bullseye vision-icon"></i>
                <h5>Our Mission</h5>
                <p>To provide holistic education that combines academic excellence with character development, sports, and co-curricular activities.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="vision-card">
                <i className="fas fa-heart vision-icon"></i>
                <h5>Our Values</h5>
                <p>Integrity, Discipline, Excellence, Respect, Innovation, and a spirit of Service to the community and nation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
